export const DEFAULT_CMS_PAGE_SIZE = 100;
